export default __webpack_public_path__ + "static/media/021-walkie-talkie.ae53b9fe.png";